import { Outlet } from "react-router-dom";

import { CmtLayout } from "@app/components/layout/CmtLayout.tsx";
import { KeycloakAuthenticator } from "@app/keycloak/KeycloakAuthenticator.tsx";

export const HomePage = () => {
  return (
    <CmtLayout>
      <KeycloakAuthenticator>
        <Outlet />
      </KeycloakAuthenticator>
    </CmtLayout>
  );
};
